// extracted by mini-css-extract-plugin
export default {"wrapper":"Header_wrapper__+KJLy","right":"Header_right__aQqPZ"};